import React from "react";

/**
 * Official Telegram paper-plane glyph. Simplified single-path SVG that
 * renders crisply at any size and inherits colour via `currentColor` so
 * it drops into buttons, sidebar rails, and cards without any per-callsite
 * fill fiddling. `size` prop matches the lucide-react API so callers can
 * swap it in without pattern shifts.
 */
export default function TelegramIcon({ size = 20, className = "", strokeWidth: _strokeWidth = 0, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      <path d="M9.036 15.457l-.373 4.226c.534 0 .765-.223 1.045-.49l2.509-2.335 5.203 3.75c.953.516 1.63.245 1.878-.868l3.404-15.44h.001c.293-1.393-.507-1.945-1.427-1.604L1.09 9.487C-.276 10.03-.258 10.79.86 11.144l4.767 1.482 11.083-6.874c.522-.335.998-.15.607.185l-8.281 9.52z" />
    </svg>
  );
}
